var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { Field } from './field';
import { Icon } from './icon';
import { Input } from './input';
import { SearchIcon } from '@shapeable/icons';
import { useVisibility } from '../hooks/use-visibility';
var cls = classNames('search-bar');
export var SearchBarDefaultProps = {
  placeholder: 'Search',
  variant: 'default',
  iconSize: 30
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SearchFieldStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding-bottom: ", ";\n    border-bottom: 1px solid ", ";\n    align-self: stretch;\n    transition: border-color 0.3s;\n    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 4px inset;\n    \n    label {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    padding-bottom: ", ";\n    border-bottom: 1px solid ", ";\n    align-self: stretch;\n    transition: border-color 0.3s;\n    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 4px inset;\n    \n    label {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.UNIT(1), theme.COLOR('line-mid'), theme.COLOR('text'), function (_a) {
    var variant = _a.variant;
    return variant === 'allBorders' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      background-color: ", ";\n      padding: ", ";\n      border-radius: ", ";\n      &:focus-within {\n        border: 1px solid ", ";\n      }\n    "], ["\n      border: 1px solid ", ";\n      background-color: ", ";\n      padding: ", ";\n      border-radius: ", ";\n      &:focus-within {\n        border: 1px solid ", ";\n      }\n    "])), theme.COLOR('line-semi-subtle'), theme.COLOR('bright'), theme.UNIT(2), theme.UNIT(2), theme.COLOR('primary'));
  }, function (_a) {
    var variant = _a.variant;
    return variant === 'bottomBorder' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      box-shadow: none;\n      border: none;\n      border-bottom: 1px solid ", ";\n\n      &:focus-within {\n        border-bottom: 1px solid ", ";\n      }\n    "], ["\n      box-shadow: none;\n      border: none;\n      border-bottom: 1px solid ", ";\n\n      &:focus-within {\n        border-bottom: 1px solid ", ";\n      }\n    "])), theme.COLOR('line-mid'), theme.COLOR('primary'));
  }, function (_a) {
    var variant = _a.variant;
    return variant === 'header' && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border-bottom: 1px solid transparent;\n      padding-bottom: 0;\n      width: 30px;\n      transition: width 0.6s ease;\n      cursor: pointer;\n    "], ["\n      border-bottom: 1px solid transparent;\n      padding-bottom: 0;\n      width: 30px;\n      transition: width 0.6s ease;\n      cursor: pointer;\n    "])));
  }, function (_a) {
    var variant = _a.variant,
      isExpanded = _a.isExpanded;
    return variant === 'header' && isExpanded && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        border-bottom: 1px solid ", ";\n        width: 300px;\n    "], ["\n        border-bottom: 1px solid ", ";\n        width: 300px;\n    "])), theme.COLOR('line-mid'));
  })
});
var SearchIconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: ", ";\n    flex-shrink: 0;\n  "], ["\n    padding: ", ";\n    flex-shrink: 0;\n  "])), theme.UNIT(0.5))
});
var SearchStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 100%;\n    padding: ", ";\n    border: none;\n    background: none;\n    &:focus {\n      outline: none;\n    }\n\n    ", "\n\n    ", "\n\n  "], ["\n    width: 100%;\n    padding: ", ";\n    border: none;\n    background: none;\n    &:focus {\n      outline: none;\n    }\n\n    ", "\n\n    ", "\n\n  "])), theme.UNIT(4), function (_a) {
    var variant = _a.variant;
    return variant === 'allBorders' && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), theme.UNIT(1), theme.UNIT(4));
  }, function (_a) {
    var variant = _a.variant;
    return variant === 'header' && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      font-size: 1em;\n    "], ["\n      font-size: 1em;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SearchField: styled(Field)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), SearchFieldStyles),
  SearchIcon: styled(Icon)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SearchIconStyles),
  Search: styled(Input)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), SearchStyles)
};
export var SearchBar = function (props) {
  var className = props.className,
    searchTerm = props.searchTerm,
    onChange = props.onChange,
    placeholder = props.placeholder,
    variant = props.variant,
    iconSize = props.iconSize;
  var _a = useVisibility('searchBar', false),
    isVisible = _a.isVisible,
    useClickOutside = _a.useClickOutside,
    toggle = _a.toggle;
  var ref = useClickOutside();
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, React.createElement(My.SearchField, {
    isExpanded: isVisible,
    variant: variant
  }, React.createElement(My.SearchIcon, {
    onClick: toggle,
    size: iconSize
  }, React.createElement(SearchIcon, null)), React.createElement(My.Search, {
    type: 'text',
    onChange: onChange,
    value: searchTerm,
    placeholder: placeholder,
    variant: variant
  })));
};
SearchBar.defaultProps = SearchBarDefaultProps;
SearchBar.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;